
import React, { useState, useEffect } from "react";
import { useNavigate,Link } from "react-router-dom";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import delivery from "../assets/images/deliveryBike.png";
import discountImg from "../assets/images/cart-discount.png";
import pickup from "../assets/images/pickUp.png";
import exclamation from "../assets/images/exclamation.png";
import ApiService from "../services/ApiService";
import PageLoader from "../components/PageLoader";
// import UserInfoPopup from "../components/UserInfoPopup";
import Header from "../components/Header";
import { toast } from "react-toastify";
import { FaCartPlus } from "react-icons/fa6";

const Cart = () => {
  const [activeTab, setActiveTab] = useState(localStorage.getItem('type') || 'delivery');
  const [cart, setCart] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  // const [infoPopup, setInfoPopup] = useState(false);
  const [delivery_instruction, setDeliveryInstruction] = useState("");
  const address = JSON.parse(localStorage.getItem("address"));
  const branch = JSON.parse(localStorage.getItem("branch"));
  const user = JSON.parse(localStorage.getItem("user"));
  const searchParams = new URLSearchParams(window.location.search);
  const offer = searchParams.get('offer') || '';
  const [apply_loyalty, setAppLoyalty] = useState(localStorage.getItem('apply_loyalty') === 'true');
  const [promo_code, setPromoCode] = useState(localStorage.getItem('promo_code') || null);
  const [inputValue, setInputValue] = useState(localStorage.getItem('promo_code') || ''); // Temporary input state

  const navigate = useNavigate();

  
  useEffect(() => {
    window.scrollTo(0, 0);
    // console.log(activeTab);
    if (activeTab=='pickup' && !branch) {
      navigate('/?tab=pickup&change=true&goto=cart');;
    }
    
    // Handle offer from URL parameters
    if (offer && !promo_code) {
      setPromoCode(offer);
      setInputValue(offer);
      localStorage.setItem('promo_code', offer);
    }
    
    
    getCart();
    localStorage.setItem('type',activeTab);
  }, [activeTab, promo_code, offer, apply_loyalty]);

  useEffect(() => {
   
    localStorage.setItem('delivery_instruction', delivery_instruction);
  }, [delivery_instruction]);

  const getCart = async () => {
    try {
      setIsLoader(true);
      let  apiData= {type:activeTab, user_address_id: address?._id, branch_id: branch?._id};
      
      if(offer){
        apiData.promo_code = offer;
      }
      if(promo_code){
        apiData.promo_code = promo_code;
      }
      if(apply_loyalty){
        apiData.apply_loyalty = apply_loyalty;
      }
      const response = await ApiService.request({
        method: "GET",
        url: "/getCart",
        data: apiData
      });
      const data = response.data;

      console.log(data);
      if (data.status) {
        const items=data.data.cartItems || [];
        localStorage.setItem('cart_count',items.length);
        setCart(data.data);
      
      } else {
        toast.error(data.message);
        setInputValue('');
        setPromoCode('');
        localStorage.removeItem('promo_code');
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
    }
  };

  const updateCartItem = async (item_id,addons , quantity) => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "POST",
        url: "/updateCartItem",
        data:{
          item_id, quantity, addons,
          type:activeTab,
          user_address_id: address?._id,
          branch_id: branch?._id
        }
      });
      const data = response.data;

      if (data.status) {
        // toast.success(data.message);
        getCart();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
    }
  };

  const nextToCheckout = () => {
    if(user.is_guest){
      navigate('/login');
      // setInfoPopup(true);
    }else{
      if (promo_code) {
        localStorage.setItem('promo_code',promo_code);
      }
      else if (offer) {
        localStorage.setItem('promo_code',offer);
      }
      localStorage.setItem('apply_loyalty',apply_loyalty);
      navigate('/checkout')
    }     
  };
  
  const removePromo = async () => {
      setInputValue('');
      setPromoCode('');
      localStorage.removeItem('promo_code');
      navigate('/cart');
      // getCart(); // Refresh cart to remove promo discount
  };

   

  return (
    <div className="">
      {isLoader ?(
        <PageLoader />
      ):(
      <div className="main-heading container">
        <Header title={'Cart'} back={'/items'}/>

        {/* Delivery Tab */}
        <div className="main-toggle d-flex justify-content-center align-items-center mb-4">
          <div className="toggle-container">
            <div
              className={`toggle-btn ${activeTab === "delivery" ? "active" : ""}`}
              onClick={() => { setActiveTab("delivery"); } }
            >
              <img src={delivery} alt="Delivery" className="icon" />
              <span>Delivery</span>
            </div>
            <div
              className={`toggle-btn ${activeTab === "pickup" ? "active" : ""}`}
              onClick={() => {setActiveTab("pickup"); } }
            >
              <img src={pickup} alt="Pickup" className="icon gray-icon" />
              <span className="gray-text">Pick up</span>
            </div>
          </div>
        </div>

        {/* Products */}
        <div className="row mx-2">
          {cart.cartItems && cart.cartItems.map((item, index) => (
            <div className="col-12 col-md-6 my-2">
              <div className="border bg-white rounded p-3">
                <div className="row align-items-center">
                  <div className="col-8 deal-data">
                    <h6>{item?.item?.title}</h6>
                    <p className="text-muted item-des">
                      {item.addons && item.addons.map((addon, aIndex) => (
                        <span>{addon.quantity}x {addon?.item?.title}</span>
                      ))}
                    </p>
                    <div className="d-flex below-section">
                      <h5 className="text-base fw-normal mt-2">AED {item?.total_price} </h5>
                          <div className="d-flex  counter quantity-btn">
                            <button className="btn btn-success btn-minus"
                              onClick={() => updateCartItem(item.item_id, item.addons, item.quantity-1)}
                            > – </button>
                            <div  className="bg-white text-success fw-bold quantity-counter" >
                              {item.quantity}
                            </div>
                            <button
                              className="btn btn-success btn-plus"
                              onClick={() => updateCartItem(item.item_id, item.addons, item.quantity+1)}
                            >  + </button>
                          </div>
                    </div>
                      {item.instruction && 
                        <div className="">
                            <img src={exclamation} alt="" style={{width:'22px', height:'22px'}} />
                            <span>{item.instruction}</span>
                        </div>
                      }
                  </div>
                  <div className="col-4 text-end">
                    <img
                      src={item.item?.image}
                      alt={item.item?.title}
                      className="item-img item-img-1"
                    />
                  </div>
                  
                </div>
              
              </div>
            </div>
          ))}
        </div>


          
        {cart.cartItems ?(


          <div className="row mx-3">
            {/* Apply Discounts */}
            <div className="apply-discounts p-3 border-bottom pb-4">
              <div className="d-flex justify-content-between">
                <h4>Apply Discounts</h4>
                <Link to={'/promotions'} className="cart-discount-p">View Offers</Link>
              </div>
              <div className="d-flex justify-content-between cart-discount">
                <input value={inputValue}
                  type="text" 
                  onChange={(e) => setInputValue(e.target.value.toUpperCase().trim())}
                  placeholder="Enter the code here"
                  className="rounded"
                />
                <img src={discountImg} />
                <button className="btn btn-lg rounded bg-black text-white" disabled={!inputValue}
                  onClick={() => {
                    setPromoCode(inputValue);
                    localStorage.setItem('promo_code', inputValue);
                    getCart();
                  }}
                  >
                  Apply
                </button>
              </div>
            </div>

            {/* Subtotal */}
            <div className="apply-discounts p-3 border-bottom pb-4">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="fw-bold">Subtotal</h5>
                <h4 className="fw-bold">AED {cart.subTotal}</h4>
              </div>
              {cart.deliveryCharges > 0 &&
                <div className="d-flex justify-content-between align-items-center border-bottom my-4">
                  <h6 className="fw-normal">Delivery Fee</h6>
                  <h6 className="fw-normal">AED {cart?.deliveryCharges}</h6>
                </div>
              }
              {cart.vat_amount > 0 &&
                <div className="d-flex justify-content-between align-items-center border-bottom my-4">
                  <h6 className="fw-normal">VAT</h6>
                  <h6 className="fw-normal">AED {cart.vat_amount}</h6>
                </div>
              }
              {cart.promo_code  &&
                <div className="d-flex justify-content-between align-items-center border-bottom my-4">
                  <h6 className="fw-normal">
                    <span className="promo-code"> {(offer)?'Offer':'Promo Code'}: </span>  <span className="text-base">{promo_code || offer}</span>
                    <span onClick={removePromo} className="bi bi-x fs-4 text-dark pt-2 cursor-pointer"></span>
                  </h6>
                  <h6 className="fw-normal promo-code">AED {cart.promo_discount}</h6>
                </div>
              }
              {cart.loyalty_points > 0  &&
              <div className="d-flex justify-content-between align-items-center my-3">
                <h6 className="fw-semibold">Redeem Points - <small className="text-primary"> Current Points: {cart.loyalty_points} </small></h6>
                <input type="checkbox" class="checkbox cart-checkbox"  checked={apply_loyalty} disabled={cart.loyalty_discount > cart.subTotal}
                onChange={(e) => {
                  setAppLoyalty(e.target.checked);
                  localStorage.setItem('apply_loyalty', e.target.checked);
                }} />
              </div>
              }
              {cart.loyalty_points > 0 && 
                <p className="border-bottom">
                  Max you can redeem for this order 
                  <b className="fw-semibold"> {cart.max_redeemable_points} point =  AED {cart.loyalty_discount}</b>
                </p>
              }
              <div className="d-flex justify-content-between align-items-center border-bottom my-4">
                <h4 className="fw-normal">
                  <span className="fw-bold">Total</span> (incl.VAT)
                </h4>
                <h5 className="fw-bold">AED {cart.grand_total}</h5>
              </div>
              <div className="my-4">
                <h5>{activeTab==='delivery'?'Delivery':'Pickup'} Instructions</h5>
                <textarea
                  rows={3}
                  placeholder="Write Instructions"
                  className="shadow rounded form-control border-0 p-3"
                  value={delivery_instruction}
                    onChange={(e) => setDeliveryInstruction( e.target.value )}
                ></textarea>
                <div className="cart-btn mt-3 d-flex justify-content-center align-items-center">
                  <Link to="/items" className="btn1 rounded btn btn-lg">Add Items</Link>
                  {cart.cartItems && 
                    // <Link to="/checkout">
                      <button className="btn2 btn rounded btn-lg ms-3 text-white"  onClick={()=> nextToCheckout()}>
                        Checkout
                      </button>
                    // </Link>
                  }
                </div>
              </div>
            </div>
          </div>
        ):(
          <div className="no-item text-center my-5">
             <p>
                <FaCartPlus className="fs-1 text-secondary" />
            </p>
            <h4 className="my-3">No Item in Cart</h4>
            <Link to="/items" className="btn rounded btn-base btn-lg">Add Items</Link>
          </div>

        )}


      </div>
      )}
      
    </div>
  );
};

export default Cart;
